import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`

export const HiddenInput = styled.input`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  position: absolute;
  cursor: pointer;
  display: block;
  opacity: 0;
`
